import { render, staticRenderFns } from "./ReglementTable.vue?vue&type=template&id=061a2c3a&scoped=true"
import script from "./ReglementTable.vue?vue&type=script&lang=js"
export * from "./ReglementTable.vue?vue&type=script&lang=js"
import style0 from "./ReglementTable.vue?vue&type=style&index=0&id=061a2c3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061a2c3a",
  null
  
)

export default component.exports